import React, { useState } from "react";
import { Tab, Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { useAuth } from "../../../../hooks";
import { MultiPartnerForm, PartnerProfile } from "../../../../components/Admin/PartnersCmp";
import "./Page_Partner_Profile.scss";

export function Page_Partner_Profile() {
  const { user } = useAuth();
  
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <PartnerProfile reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="register-page">
        <div className="register-page__add">
          {/* Se oculta el botón si el usuario ya tiene rol partner */}
          {user?.user?.holded.toLowerCase() !== "" || user?.user?.holded.toLowerCase() !== null && (
            <Button  onClick={onOpenCloseModal}>
              Alta Partner
            </Button>
          )}
        </div>
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Registro de Partner"
      >
        <MultiPartnerForm onClose={onOpenCloseModal} onReload={onReload} user={user} />
      </BasicModal>
    </>
  );
}
